import React from 'react';
import { CSSObject, FlexProps, Icon } from '@chakra-ui/react';
import { Prohibited } from '@styled-icons/foundation/Prohibited';
import { BetCardSchema } from '@/components/Betslip/components/BetCard/styles/BetCard.styles';

export const betCardStyles: BetCardSchema = {
  spanPropositionType: {
    color: 'beta.300',
    fontSize: 'xs',
  },
  flexWrapperMysteryRollover: {
    gap: 1,
  },
  buttonBonusBetsProps: {
    display: 'flex',
    variant: 'secondary',
    size: '2xs',
    px: '1.5',
    alignSelf: 'flex-start',
    textTransform: 'uppercase',
    h: '6',
    spanProps: {
      fontFamily: 'accent',
      textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
      fontWeight: 'bold',
      fontSize: '11px',
      px: '0',
      pt: 0.5,
    },

    _disabled: {
      boxShadow: 'none',
      border: 'none',
      bg: 'blackAlpha.300',
      color: 'beta.50',
      opacity: '1',
      '& > span': {
        _first: {
          color: 'green.300',
          mr: '1',
        },
      },
    },

    sx: {
      '.chakra-button__icon': {
        display: 'none',
      },

      '&&[data-isbonusbet="true"]': {
        _disabled: {
          w: '100%',
          mt: '-3',
          bg: 'blackAlpha.300',
          borderRadius: 'none',
          borderBottomRadius: 'md',
          boxShadow: 'none',

          '.chakra-button__icon': {
            display: 'block',
            color: 'gamma.100',
            mr: '0.5',
          },

          spanProps: {
            fontFamily: 'accent',
            fontWeight: 'medium',
            fontSize: '2xs',
            pt: '0.5',
            textShadow: '0px 3px 3px rgba(0, 0, 0, 0.20)',
            textTransform: 'uppercase',
          },
        },

        bg: 'blackAlpha.500',
        boxShadow:
          '0px 2px 0px 0px rgba(0, 0, 0, 0.30) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
        color: 'white',
        fontWeight: 'medium',
        borderRadius: 'md',
        h: '6',
        spanProps: {
          fontFamily: 'accent',
          fontWeight: 'bold',
          fontSize: '11px',
          px: '2',
          pt: '0.5',
        },
      },
    },
  },
  iconBetCardSvgMysteryBet: {
    color: 'white',
  },
  flexWrapperMysteryBetFooterBetPlaced: {
    pl: 2,
    py: '5px',
    alignItems: 'flex-start',
    gap: 1.5,
  },
  flexWrapperMysteryBetFooterBetReview: {
    bg: 'blackAlpha.500',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset',
    color: 'alpha.100',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5',
    p: '0.5',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 'xs',
    fontFamily: 'accent',
    sx: {
      _last: {
        bg: 'alpha.700',
        boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.2)',
        justifyContent: 'flex-start',
      },
    },
  },
  spanBetOdds: {
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'body',
    color: 'gamma.100',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  spanRaceInfo: {
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'body',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    color: 'white',
  },
  flexBetInfo: {
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
    lineHeight: '1.25',
  },
  iconMysteryBetFooter: {
    color: 'beta.300',
    alignSelf: 'unset',
    mr: 3,
    mb: '7px',
    ml: 1,
  },
  flexRaceInfoOverride: {
    fontSize: 'xs',
  },
  buttonBetPropositionClosedProps: {
    variant: 'unstyled',
    bg: 'gamma.600',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
    borderRadius: 'base',
    color: 'white',
    fontWeight: 'bold',
    fontSize: 'xs',
    px: '3',
    py: '2',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
  buttonStakeProps: {
    variant: 'primary',
    color: 'blackAlpha.800',
    fontSize: 'sm',
    fontWeight: 'bold',
    h: '42px',
    maxW: '45px',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.5)',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    pt: '5px',
  },
  betCardSVG: {
    fill: 'unset',
    color: 'beta.300',
    pb: '7px',
  },
};

export const betCardErrorFlexTextProps: FlexProps = {
  color: 'red.100',
  textShadow: '0px 1px 1px rgba(0, 0, 0, 0.35)',
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const betCardErrorFlexProps: FlexProps = {
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  color: 'red.100',
  bg: 'red.700',
  borderRadius: 'md',
  w: '95%',
  mx: 'auto',
  mt: '1',
  justifyContent: 'center',
  minH: '8',
  alignItems: 'center',
  px: '2',
  py: '1',
};

export const IconButtonThemed: CSSObject = {
  w: 'unset',
  minW: 'unset',
  justifyContent: 'right',
  color: 'white',
  transition: 'all .2s ease-in-out',
  _hover: {
    color: 'alpha.50',
  },
};

export const InfoBetOdds: CSSObject = {
  color: 'white',
  display: 'flex',
  fontWeight: 'semibold',
  fontSize: 'sm',
};

export const EventTitle: CSSObject = {
  fontWeight: 'extrabold',
  fontSize: 'sm',
  flex: '1',
  textTransform: 'capitalize',
  color: 'white',
  mb: 0,
};

export const EventMarketName = (isExtraInfo: boolean) => ({
  display: !isExtraInfo && 'none',
  fontSize: 'xs',
  color: 'beta.500',
  fontWeight: 'bold',
  textTransform: 'capitalize',
});

export const EventSubtitle: CSSObject = {
  textTransform: 'capitalize',
  fontSize: 'xs',
  fontWeight: 'medium',
  '&&': {
    color: 'white',
  },
};

export const ExoticsPlaceContainer: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'xs',
  ml: '8',
};

export const TextExoticSelections: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const FlexPlacedContainer: CSSObject = {
  p: '2',
};

export const BetPlaced: CSSObject = {
  bgGradient: 'linear(to-b, white, white)',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2), inset 0px 1px 0px #FFFFFF',
  color: 'gray.600',
  borderRadius: 'base',
  flexDirection: 'column',
  px: '2',
  py: '1.5',
};

export const TextExoticsLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const TextExoticsInfo: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const BetPlacedRow: CSSObject = {
  justifyContent: 'flex-start',
};

export const TextPlacedLabel: CSSObject = {
  flex: '1',
};

export const BetCardSVG = (header: boolean) => ({
  color: header ? 'beta.500' : 'white',
  boxSize: '6',
  display: header ? 'block' : 'none',
  mr: '0',
  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
});

export const IconPropositionClosed = () => (
  <Icon as={Prohibited} sx={{ boxSize: '5' }} />
);

export const EventRule: CSSObject = {
  color: 'gamma.800',
};

export const BetPropositionClosedError: CSSObject = {
  bg: 'rgba(28, 46, 77, 0.7)',
  borderRadius: 'md',
  position: 'absolute',
  top: '-1px',
  left: '-1px',
  w: 'calc(100% + 2px)',
  h: 'calc(100% + 2px)',
  pb: '0',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  zIndex: '3',
};

export const BetOdds: CSSObject = {
  mb: '0.5',
};

export const DefaultStakeFlexbox: CSSObject = {
  gap: '1',
};

export const ExoticsFooterContainer: CSSObject = {
  pt: '0',
  pr: '2',
  pl: '2.5',
};

export const FlexBonusBetsWrapper = (): CSSObject => ({
  '&&': {
    mt: '0',
  },
});
